import type { JSX } from 'react';

import { Box,Typography } from '@mui/material';

import { CopyToClipboard } from './CopyToClipboard';

interface IInlineStyles {
    [key: string]: unknown
}

type PagetitleProps = {
  resourceType: string;
  resourceName?: string;
  resourceId: string;
  shouldShowResourceName?: boolean;
  resourceTypeInlineStyles?: IInlineStyles;
  useDefaultResourceTypeTitle?: boolean;
  copyToClipboard?: boolean;
};

const DEFAULT_RESOURCE_TYPE_INLINE_STYLES: IInlineStyles = {
    width: '17%',
    ':hover': { width: '100%' },
    justifyContent: 'left',
    display: 'flex',
    alignItems: 'center'
};

export function ResourceDetailHeader({
    resourceType,
    resourceName,
    resourceId,
    shouldShowResourceName = true,
    resourceTypeInlineStyles = DEFAULT_RESOURCE_TYPE_INLINE_STYLES,
    useDefaultResourceTypeTitle = true,
    copyToClipboard = true
}: Readonly<PagetitleProps>): JSX.Element {
    const resourceTypeTitle = useDefaultResourceTypeTitle ? `${resourceType} ID:` : `${resourceType}:`;
    return (
        <Box>
            {shouldShowResourceName &&
                <Typography variant="h5" gutterBottom component="div">
                    {resourceName}
                </Typography>
            }
            <Typography
                variant="body1"
                gutterBottom
                component="div"
                color="info.light"
                noWrap
                sx={resourceTypeInlineStyles}
            >   { copyToClipboard && <CopyToClipboard
                    content={resourceId}/>
                }
                <span className='ellipsis'>{`${resourceTypeTitle} ${resourceId}`}</span>
            </Typography>
        </Box>
    );
}
